export enum tiposCamposObrigatorios {
  DADOS_OBRIGATORIOS_ENVIO_ADMISSAO = '1',
  DADOS_OBRIGATORIOS_ENCAMINHAMENTO = '2',
  DADOS_OBRIGATORIOS_ENVIO_ADMISSAO_PRELIMINAR = '3'
}
